<template>
<div class="categord-add">
  <el-form ref="editForm" label-width="100px" :model="editJson" :rules="rules">
    <el-form-item label="部门名称" prop="department">
      <el-popover
        placement="bottom-start"
        width="450"
        popper-class="popper-tree categord-add-dep"
        @hide="handledHide"
        trigger="click">
        <el-tree
          :props="defaultProps"
          :data="treeData"
          show-checkbox
          node-key='id'
          ref="tree"
          highlight-current
          check-strictly
          :default-expanded-keys="expandedData"
          @check-change="handleCheckChange">
        </el-tree>
        <el-input slot="reference" v-model="editJson.department" placeholder="请选择部门名称" clearable></el-input>
      </el-popover>
    </el-form-item>
    <el-form-item label="类别编号" prop="itemNo">
      <el-input v-model="editJson.itemNo"></el-input>
    </el-form-item>
    <el-form-item label="类别名称" prop="itemName">
      <el-input v-model="editJson.itemName"></el-input>
    </el-form-item>
   <el-form-item label="状态" prop="status">
      <el-switch v-model="editJson.status" :inactive-value="0" :active-value="1"></el-switch>
      &nbsp;&nbsp;{{ editJson.status == 1 ? "启用": '停用' }}
    </el-form-item>
    <el-form-item label-width="0" class="atb-no-margin">
        <div class="atb-text-right">
        <!-- 保存 -->
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
        <!-- 取消 -->
        <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">取消</el-button>
        </div>
  </el-form-item>
  </el-form>
</div>

</template>
<script>
import editMixin from '@/mixins/edit.mixin'
import _ from 'lodash';
export default {
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      id: 'id',
      rules: {
        department: [
          { required: true, message: '请选择部门', trigger: 'change' },
        ],
        itemNo: [
          { required: true, message: '请输入类别编号', trigger: 'blur' },
          { max: 64, message: '最多64个字符', trigger: 'blur' }
        ],
        itemName: [
          { required: true, message: '请输入类别编号', trigger: 'blur' },
          { max: 64, message: '最多64个字符', trigger: 'blur' }
        ]
      },
      addApi: this.$api.Identity.Categord.create,
      editApi: this.$api.Identity.Categord.update,
      editMethod:'put',
      depData:[],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      depList:[],
      checkId:"",
      checkName:'',
      copyTreeData:[],
      expandedData:[],
    }
  },
  mounted(){
    this.getDep().then(()=>{
      if(this.isEdit){
        this.$nextTick(()=>{
          const dep = this.depList.find(t=>t.code===this.editData.departmentNo);
          this.$refs.tree.setCheckedKeys([dep.id]);
          this.$set(this.editJson,'department',this.editData.departmentName);
        })
      }else{
        this.$set(this.editJson,'status', 1)
      }
    });
  },
  methods:{
     resetSubmitParams(params){
      const self=this;
      const depNameArr=[];
      const dep=this.checkId? this.depList.find(t=>t.id===this.checkId): this.depList.find(t=>t.code===params.departmentNo);
      depNameArr.unshift(dep.displayName);
      concatDepName(dep.parentId);
      function concatDepName(depParentId){
        const parentNode=self.depList.find(t=>t.id===depParentId);
        if(parentNode){
            depNameArr.unshift(parentNode.displayName);
            concatDepName(parentNode.parentId);
        }
      }
      const depParam= { departmentName:depNameArr.join('/'), departmentNo: dep.code}
      return Object.assign({}, params, depParam)
     },
     resDepData(data){
        this.depData=data;
     },
     handleNodeClick(data) {
        console.log(data);
     },
     async getDep() {
       await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList=res.data||[];     
            const obj ={};
            this.depList.forEach(v=>{
             const objClone=_.cloneDeep(obj);
             objClone.id= v.id,
             objClone.label= v.displayName
           if(v.parentId===null){
              this.expandedData.push(v.id);
              objClone.children= this.depList.filter(t=>t.parentId===v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData=_.cloneDeep(this.treeData);
            }
          });
        });
      },
      generateMenu(chs){
        chs.forEach(v=>{
          v.label= v.displayName
          v.children = this.depList.filter(t=>t.parentId === v.id)
          this.generateMenu(v.children);
        });
    },
    handleCheckChange(data, checked){
      const depNameArr=[];
      const self=this;
      function concatDepName(depParentId){
        const parentNode=self.depList.find(t=>t.id===depParentId);
        if(parentNode){
            depNameArr.unshift(parentNode.displayName);
            concatDepName(parentNode.parentId);
        }
      }
      if(checked === true){
        this.checkId=data.id;
        this.checkName=data.label;
        depNameArr.unshift(data.label);
        concatDepName(data.parentId);
        this.$set(this.editJson,'department',depNameArr.join('/'));
        this.$refs.tree.setCheckedKeys([data.id]);
      }else{
        if(this.checkId === data.id) {
          this.$refs.tree.setCheckedKeys([]);
        }
      }
    },
    getChildrenMenu(depData){
      let depTree=[];
      depData.forEach(t=>{
        if(t.label.indexOf(this.editJson.department.split('/')[this.editJson.department.split('/').length-1]) != -1){
        depTree.push(t)
        }else{
          if(t.children && t.children && t.children.length){
            t.children = this.getChildrenMenu(t.children)
            if(t.children && t.children.length){
              depTree.push(t)
            }
          }
        }
      });
      return this.treeData=depTree;
    },
    handledHide(){
       this.$nextTick(()=>{
        if(!this.$refs.tree.getCheckedKeys().length){
          this.$set(this.editJson,'department','');
        }
      });
    }
  },
  watch:{
    "editJson.department":{
      handler(val){
            const depTree=_.cloneDeep(this.copyTreeData);
            this.getChildrenMenu(depTree);
          if(!val){
           this.$refs.tree.setCheckedKeys([]);
        }
      }
    }
  }
}
</script>
<style>
  .categord-add-dep{
    height: 300px;
    overflow: auto;
  }
</style>
